<template>
    <div class="dingdan">
        <breadcrumb  :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'订单列表'}]"/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                    <el-form-item label="创建人编码/名称">
                        <el-input v-model="formInline.cuserCodeNameLike" placeholder="请输入" style="width: 1.3rem"></el-input>
                    </el-form-item>
                    <el-form-item label="售达方编码/名称">
                        <el-input v-model="formInline.sdfCodeNameLike" placeholder="请输入" style="width: 1.3rem"></el-input>
                    </el-form-item>
                    <el-form-item label="订单类型">
                        <brselect category="xiaoshou_quyu" :v="formInline.orderCategory"
                                  v-model="formInline.orderCategory"  clearable></brselect>
                    </el-form-item>
                    <el-form-item label="销售组织">
                        <brselect category="xiaoshou_zuzhi" :v="formInline.saleGroupCode"
                                  v-model="formInline.saleGroupCode"  clearable ></brselect>
                    </el-form-item>
                    <el-form-item label="订单状态">
                        <brselect style="width:2rem" clearable category="order_status" :v="formInline.status"
                                  v-model="formInline.status"></brselect>
                    </el-form-item>
                    <el-form-item class="h-formBtnOut" style="margin-right: 0">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn" @click="resetData"
                                   style="background-color:white;color:black;border:1px solid #d1d1d1">重置
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.6rem;"
                                   @click="imgfalse3" >
                            新建订单
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="h-table h-mrt30">
            <el-table
                    ref="ddtable"
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    stripe
					border
                    :show-overflow-tooltip="true"
                    style="width: 100%"
            >
                <el-table-column
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="sapCode"
                        label="订单号"
                        width="190">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        width="190">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="产品名称"
                        width="190">
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="订单状态"
                        width="170">
                    <template scope="scope">
                        {{scope.row.status|dictname('order_status')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="orderCategory"
                        label="订单类型"
						:show-overflow-tooltip="true"
                        width="190">
                    <template scope="scope">
                        {{scope.row.orderCategory|dictname('xiaoshou_quyu') }}  {{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="saleGroupCode"
                        label="销售组织编码"
						:show-overflow-tooltip="true"
                        width="250">
                    <template scope="scope">
                        {{scope.row.saleGroupCode|dictname('YLSalesOrganization_agent')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="soldToCode"
                        label="售达方编码"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="soldToName"
                        label="售达方名称"
						:show-overflow-tooltip="true"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="soldToAreaCode"
                        label="售达方地区"
						:show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{scope.row.soldToAreaCode|dictname('YLRegion')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="currencyCode"
                        label="币种编码"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="orderPrice"
                        label="订单总价"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="orderNetWorth"
                        label="订单净价值"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="disChannelCode"
                        label="分销渠道编码"
                        :show-overflow-tooltip="true"
                        width="190">
                    <template scope="scope">
                        {{scope.row.disChannelCode|dictname('fenxiao_qudao')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="customerChannelCode"
                        label="客户渠道"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{scope.row.customerChannelCode|dictname('sales_region')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="orderProjectName"
                        label="项目名称"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="cuname"
                        label="创建人名称"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        width="190">
                </el-table-column>

                <el-table-column
                        prop="proNumber"
                        label="数量"
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="finalPrice"
                        label="成交价"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="totalprice"
                        label="总价"
                        width="80">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="150"
                >
                    <template slot-scope="scope">
                        <div>
                            <div v-if="scope.row.status == '10'">
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="handleEdit(scope.row)">编辑</el-button>
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="handleDelete(scope.row)">删除</el-button>
								<!-- <div class="l-operationBox">
									<span class="l-operationlist br-operation-xg" title="编辑" @click="handleEdit(scope.row)"></span>
									<span class="l-operationlist br-operation-delete" title="删除" @click="handleDelete(scope.row)"></span>
								</div> -->
                            </div>
                            <div v-else>
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="genzongLiuch(scope.row)">
                                    跟踪
                                </el-button>

                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="handelDetail(scope.row)">查看</el-button>
								<!-- <div class="l-operationBox">
									<span class="l-operationlist br-operation-spgz" title="跟踪审批" @click="genzongLiuch(scope.row)"></span>
									<span class="l-operationlist br-operation-look" title="查看详情" @click="handelDetail(scope.row)"></span>
								</div> -->
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                <pagination :page="formInline" @query="query" />
                <!--<el-button type="primary">导出</el-button>-->
            </div>
        </div>
        <!--创建订单弹出框-->
        <dingdadd :visible.sync="imgflag3" v-if="imgflag3" @imgfalse3="imgflag3=false" />

        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile';

    export default {
        data() {
            return {
                instid:null,
                showhistory:null,

                imgflag3: false,
                orderTypeList:[],


                tableData:[],
                //用户项目
                allProjectByUser:[],
                //是否有项目
                xiangmuTab:false,
                //销售组织，下拉
                xszz:[],
                fxqd:[],
                //表单
                formInline: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                spanArr:[],
            }
        },


        created() {
            this.query();

        //    项目
        //     this.listPro();
        },
        methods: {
            getSpanArr() {
                this.spanArr=[];
                this.tableData.forEach((item,index) => {
                    if( index === 0){
                        this.spanArr.push(1);
                        this.position = 0;
                    }else{
                        if(this.tableData[index].id === this.tableData[index-1].id ){
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        }else{
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                console.log(row)
                console.log(column)
                console.log(columnIndex)
                if (columnIndex >=4 && columnIndex <=17 && column.label !='订单状态') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
                if ( (column.label =='订单状态' || column.label =='操作' ) && row.status == '10') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },
            genzongLiuch(r) {
                console.log(r);
                this.instid = r.binstid;
                this.showhistory = true;
            },
            imgfalse3(){
              this.imgflag3 = true;
            },
            //查询该用户及所有子用户所有订单详情
            query() {
                ss.OrderMainService.selectDingdanPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    this.formInline.total = rd.total||0;
                    this.getSpanArr();
                });
            },

            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },

            // 重置按钮
            resetData() {
                this.formInline.cucode = ""
                this.formInline.cunameLike = ""
                this.formInline.orderType = ""
                this.formInline.orderCategory = ""
                this.formInline.saleGroupCode = ""
                this.formInline.orderStatus = ""
                this.q.pageSize = 10;
                this.query();
            },


            handleEdit(row){
                console.log(row)
                this.toEdit(row.orderCategory,row.orderCategory1,row.id);
                // this.$router.push({path: "/dingd/createOrder", query: {id:row.id}})
            },
            handelDetail(row){
                if(row.orderCategory == '1'){
                    this.$router.push({path: "/dingdmain/orderNxshenpi", query: {id:row.bid, instid:row.binstid, taskstatus:'1', f:'1'}})
                }else {
                    this.$router.push({path: "/dingdmain/orderWxshenpi", query: {id:row.bid,instid:row.binstid, taskstatus:'1', f:'1'}})
                }
            },
            toEdit(ddlx,ddzlx,id){
                if (ddlx == '1') {
                    //售后订单
                    if(ddzlx == '4'){
                        this.$router.push({path: "/dingd/createShouhouOrder", query: {id:id}})
                        return;
                    }else if(ddzlx == '9'){
                        //服务订单
                        this.$router.push({path:"/dingd/material/fuwu", query:{id:id}})
                        return;
                    }
                    this.$router.push({path: "/dingd/createNxOrder", query: {id:id}})
                } else if (ddlx == '2') {
                    //外销
                    this.$router.push({path: "/dingd/createWxOrder", query: {id:id}})
                    return;
                } else {
                    //上海直销

                }
            },
            handleDelete(row){

            },
            //导出Excel
            downloadExcel() {

                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.pid);
                });

                this.q.ids = idlist;
                this.q.orderCategory = this.formInline.orderCategory;
                this.q.orderType = this.formInline.orderType;
                this.q.cucode = this.formInline.cucode;
                this.q.cunameLike = this.formInline.cunameLike;
                this.q.saleGroupCode = this.formInline.saleGroupCode;
                this.q.orderStatus = this.formInline.orderStatus;

                updownfile.down("/api/swyl/v1/bsc/order/getOrderExcel?ids=" + this.q.ids, this.q.ids, "get", "data");

            },

        },

        mounted() {
        },

    }
</script>
<style scoped>
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }
    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }
    .D-date .el-cascader{
        line-height: 0;
    }

</style>



